<template>
  <div class="index">
    <div class="index-con">
      <div class="big-title">
        <span>Hotel & Transportation</span>
      </div>

      <div class="small-title sb-title">Hotel Information</div>
      <div class="text">
        The MAIQS 2026 will be held in Hangzhou, China. The recommended
        conference hotel is:
      </div>
      <div class="text hotel-list">
        <div>• Hotel: Grand New Century Hotel Hangzhou</div>
        <div>
          • Address: No. 297, No. 5 Street, Xiasha Economic Development Zone,
          Qiantang District, Hangzhou, Zhejiang, P.R. China (Postcode: 310018)
        </div>
        <div>• Tel: +86-571-88279999</div>
        <div>
          • Hotel website:
          <a
            href="https://www.hangzhounewcentury.cn/"
            target="_blank"
            class="link"
            >https://www.hangzhounewcentury.cn/</a
          >
        </div>
        <div>• Nearest metro: Line 1, Wenze Road Station (Exit C), about 500 m on foot</div>
      </div>

      <div class="small-title sb-title mt-50">Transportation</div>
      <div class="text">
        All routes below arrive at Wenze Road Station (Line 1); leave by Exit C
        and walk about 500 m to the hotel.
      </div>

      <div class="small-title_2">1. From Hangzhou Xiaoshan International Airport (HGH)</div>
      <div class="text">
        Metro: Line 1 (towards Xianghu) direct to Wenze Road — 8 stops, about 30
        min.
        <br />
        Taxi: about 40 min, subject to traffic.
      </div>

      <div class="small-title_2">2. From Hangzhou East Railway Station</div>
      <div class="text">
        Metro: Line 1 (towards Hangzhou Xiaoshan International Airport) direct to
        Wenze Road — 9 stops, about 25 min.
        <br />
        Taxi: about 30 min.
      </div>

      <div class="small-title_2">3. From Hangzhou West Railway Station</div>
      <div class="text">
        Metro: Line 19 to West Lake Cultural Square, transfer to Line 1 (towards
        Hangzhou Xiaoshan International Airport) to Wenze Road — about 26 stops,
        about 62 min by metro.
        <br />
        Taxi: about 55–70 min.
      </div>

      <div class="text note">
        Alternative station: Gaosha Road Station (Line 1), about 900 m from the
        hotel.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style scoped>
.sb-title {
  color: #0270c0 !important;
}

.mt-50 {
  margin-top: 50px;
}

.index-con {
  margin: 0 auto;
  width: 1200px;
  padding-bottom: 170px;
}

.text {
  box-sizing: border-box;
  color: #333;
  font-size: 16px;
  line-height: 2;
  padding-bottom: 20px;
}

.hotel-list div {
  line-height: 1.9;
}

.small-title {
  font-size: 17px;
  font-weight: 600;
  margin-bottom: 20px;
}

.small-title_2 {
  font-size: 17px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}

.link {
  color: #0a9a7a;
  text-decoration: underline;
}

.note {
  color: #666;
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
  }

  .index {
    padding: 40px 10px 0;
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hotelTransportation.vue